export default __webpack_public_path__ + "static/media/mariaFilo_mob_banner_5.f5bf33b6.jpg";